<template>
    <div class="under-nav">
        <a class="nav-case" :href="$route('app.corporate_banking')"  >
            <img src="/images/nav-img/sme.svg" alt="">
            <p>
                {{ $t("message.navigation.corporate") }}
            </p>
        </a>
        <a class="nav-case" :href="$route('app.individual_banking')" >
            <img src="/images/nav-img/financial.svg" alt="">
            <p>
                {{ $t("message.navigation.individual") }}
            </p>
        </a>
        <a class="nav-case" :href="$route('app.financial_institutions')">
            <img src="/images/nav-img/personal.svg" alt="">
            <p>
                {{ $t("message.navigation.financial") }}
            </p>
        </a>
<!--        <a disabled  class="nav-case coming-soon" href="#">-->
<!--            <img src="/images/nav-img/wealth.png" alt="">-->
<!--            <p>-->
<!--                {{ $t("message.navigation.management_solutions") }}-->
<!--            </p>-->
<!--            <span class="soon-pastille">{{ $t("message.navigation.soon") }}</span>-->
<!--        </a>-->
    </div>
</template>

<script>

export default {

}
</script>

<style scoped>

</style>
